<template>
  <div>
    <div>
      <div class="bg">
        <FxedTop></FxedTop>
      </div>

      <div style="background: #f1f5f8">
        <div class="pageTitle">
          <div class="sort"></div>
          <div class="currentLocation">
            当前位置：首页 > 个人中心 > {{ navActiveName }}
          </div>
        </div>
        <div class="mian" style="background: none">
          <div style="display: flex; justify-content: space-between">
            <!-- 左侧导航 -->
            <div class="navList">
              <div :class="item.active ? 'active item' : 'item'" v-for="(item, index) in navList" :key="index"
                @click="handleNav(item)">
                <!-- <img class="icon" :src="item.url" /> -->
                <div class="title">{{ item.name }}</div>
              </div>
            </div>
            <!-- 右侧内容 -->
            <div class="content">
              <div v-if="navActiveName == '我的课程'">

                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item label="课程年度">
                    <el-select v-model="formInline.classYear" placeholder="课程年度">
                      <el-option v-for="item in classYear" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="课程类型">
                    <el-select v-model="formInline.requiredType" placeholder="必修/选修">
                      <el-option label="选修课程" value="2"></el-option>
                      <el-option label="必修课程" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="课程类别">
                    <el-select v-model="formInline.courseType" placeholder="课程类别">
                      <el-option label="公需科目" value="1"></el-option>
                      <el-option label="专业科目" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="selectUser">查询</el-button>
                    <el-button plain @click="resetQuery">重置</el-button>
                  </el-form-item>
                </el-form>

                <div class="cards" v-loading="loading2" v-if="courseList.length > 0">
                  <div class="item border" v-for="(item, index) in courseList" :key="index">
                    <div style="display: flex; margin-bottom: 10px">
                      <div class="itemBody">
                        <div style="
                            position: relative;
                            width: 100%;
                            height: 100%;
                            overflow: hidden;
                            border-radius: 10px;
                          ">
                          <img v-if="item.requiredType == 1" class="itemLogo" src="@/assets/image/必修.png" />
                          <img v-if="item.requiredType == 2" class="itemLogo" src="@/assets/image/选修.png" />

                          <img :src="item.classGroupLogo ? item.classGroupLogo : noImg" style="
                              width: 200px;
                              height: 130px;
                              margin-right: 10px;
                            " />
                        </div>
                      </div>
                      <div style="flex: 1">
                        <div class="subTitle">
                          {{ item.classGroupName }}
                        </div>
                        <div class="keshi">
                          <!-- <span> 课时: {{ item.classHour }} (分钟) </span> -->
                          <span> 学时: {{ item.learnHour }} </span>
                        </div>
                        <div class="keshi">
                          <span> 讲师: </span>
                          <span>{{ item.lecturer }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="item.isComplete == 0" style="margin-bottom: 10px">
                      <div style="
                          margin-bottom: 10px;
                          font-size: 14px;
                          color: rgb(155, 155, 155);
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        ">
                        <div>未完成课程</div>
                        <div>
                          <el-button class="jixu" @click="handleUrl(item)">
                            继续学习
                          </el-button>
                          <el-button class="jixu" @click="handlekaoshi(item)" v-if="
                            item.speedRate >= 100 &&
                            item.isExam == 1 &&
                            item.isCompleteExam == 0
                          ">
                            前往考试
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div style="
                          margin-bottom: 10px;
                          font-size: 14px;
                          color: #306fbc;
                          display: flex;
                          justify-content: space-between;
                        ">
                        <div>已完成课程</div>
                      </div>
                    </div>

                    <div style="display: flex; align-items: center">
                      <div style="
                          margin-right: 10px;

                          font-size: 14px;
                          color: #9b9b9b;
                        ">
                        学习进度{{ item.speedRate }}%
                      </div>
                      <div class="proBg">
                        <div class="proDetail" :style="{ width: `${item.speedRate}%` }"></div>
                      </div>
                    </div>
                  </div>
                  <div style="
                      width: 100%;
                      display: flex;
                      justify-content: end;
                      padding: 10px 0;
                    ">
                    <el-pagination background layout="prev, pager, next" :page-size="formInline.pageSize"
                      :total="totalNum" @current-change="handleCurrentChange" @prev-click="handlePrevClick"
                      @next-click="handleNextClick">
                    </el-pagination>
                  </div>
                </div>
                <div v-else style="color: #ccc; text-align: center; line-height: 200px">
                  暂未加入课程
                </div>
              </div>
              <div v-if="navActiveName == '学习档案'">
                <div>
                  <CoursePlanCard :tabs="['公需科目', '专业科目']" @onHistoryPrint="onHistoryPrint" :requiredDone="0"
                    :requiredLeft="20" :optionalDone="3" :optionalLeft="7" :historyCredit="0"
                    planImg="https://your-image-url.jpg" planTitle="2024年西藏自治区专业技术人员继续教育公需科目培训" planTime="2024-03-04"
                    :examCredit="30" :examDone="3" planDesc="请根据学时和时间计划要求及时进行在线学习！"></CoursePlanCard>
                </div>
                <!-- <div
                    v-else
                    style="color: #ccc; text-align: center; line-height: 200px">
                    暂未加入课程
                  </div> -->
              </div>
              <!-- 完善信息 -->
              <div v-if="navActiveName == '完善信息'">
                <PerfectInfo></PerfectInfo>
              </div>

              <!-- <div v-if="navActiveName == '我的订单'">
                  <orderComponents></orderComponents>
                </div> -->

              <!-- 证书下载记录 -->
              <div v-if="navActiveName == '打印记录'">
                <div class="table" v-if="certificateList.length > 0">
                  <div class="table-row">
                    <div class="table-cell">课程名称</div>
                    <div class="table-cell">年份</div>
                    <div class="table-cell">身份证号</div>
                    <div class="table-cell">打印时间</div>
                  </div>
                  <div class="table-row" v-for="(item, index) in certificateList" :key="index">
                    <div class="table-cell">{{ item.schoolClassName }}</div>
                    <div class="table-cell">{{ item.classYear }}</div>
                    <div class="table-cell">{{ item.idCardNo }}</div>
                    <div class="table-cell">{{ item.downloadTime }}</div>
                  </div>
                </div>
                <div v-else style="color: #ccc; text-align: center; line-height: 200px">
                  暂无证书下载记录
                </div>
              </div>

              <div v-if="navActiveName == '修改密码'">
                <div>
                  <div class="form">
                    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                      <el-form-item label="姓名" prop="realName">
                        <el-input v-model="form.realName" placeholder="请输入姓名" />
                      </el-form-item>
                      <el-form-item label="身份证号" prop="idCardNo">
                        <el-input v-model="form.idCardNo" placeholder="请输入身份证号" />
                      </el-form-item>
                      <el-form-item label="新密码" prop="newPassword">
                        <el-input type="password" v-model="form.newPassword" placeholder="请输入新密码" />
                      </el-form-item>
                      <el-form-item label="确认密码" prop="password">
                        <el-input type="password" v-model="form.password" placeholder="请确认密码" />
                      </el-form-item>
                      <button type="button" class="moni" @click="setPassword" style="
                          display: block;
                          border: none;
                          width: 150px;
                          margin: 0 auto;
                        ">
                        提交
                      </button>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Verify @success="success" :mode="'pop'" :captchaType="'blockPuzzle'"
        :imgSize="{ width: '330px', height: '155px' }" ref="verify"></Verify>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { getUserInfo, setPassword, captcha } from "@/api/user";
import {
  getGroup,
  pageMyClassGroupList,
  getUserStatistics,
  mySchoolClass,
  getCertificateRecord,
} from "@/api/wkApi";
import * as cmsApi from "@/api/cms";
import FxedTop from "@/components/FxedTop.vue";
import Footer from "@/components/Footer.vue";
import PerfectInfo from "@/components/perfectInfo.vue";
import skillComponents from "./skillComponents.vue";
import CoursePlanCard from "@/components/CoursePlanCard.vue";
import Verify from "@/components/verifition/Verify.vue";
import JSEncrypt from "jsencrypt";

// 使用vux的 mapState需要引入

export default {
  components: {
    FxedTop,
    Footer,
    PerfectInfo,
    skillComponents,
    CoursePlanCard,
    Verify,
  },
  data() {
    return {
      noImg: require("@/assets/noImg.webp"),
      loading: true,
      loading2: true,
      form: {
        realName: undefined,
        idCardNo: undefined,
        newPassword: undefined,
        password: undefined,
      },
      totalNum: 0,
      formInline: {
        classYear: 2025,
        requiredType: undefined,
        courseType: undefined,
        pageNo: 1,
        pageSize: 4,
      },
      rules: {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        password: [{ required: true, message: "请确认密码", trigger: "blur" }],
      },
      showTime: false,
      time: 60,
      navList: [
        { icon: undefined, name: "我的课程", active: true },
        { icon: undefined, name: "学习档案", active: false },
        // { icon: undefined, name: "我的订单", active: false },
        // { icon: undefined, name: "我的证书", active: false },
        { icon: undefined, name: "打印记录", active: false },
        { icon: undefined, name: "完善信息", active: false },
        { icon: undefined, name: "修改密码", active: false },
        { icon: undefined, name: "退出登录", active: false },
      ],
      navActiveName: "我的课程",
      activities: [], // 通知
      courseList: [],
      userInfo: {},
      myInfo: {},
      archiveInfo: {},
      certificateList: [],
      publicKey: `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvHdaUj121trhuXVQNTuweOAQIIGk1DOMIsN2Wt4F0B9mLtDJslW6dWVz8A4u3mZ6Jhu4SizXXWq63mD6Xaq/yUC8NkH3GBS8XCClQqZ6eIJR8zKBNkrpRQMgo0apiRThoksGnd/1AE+vrgZZZ9g/1bhyn2KJ2bY6qZJGb56XyKFBv7zciZ6q/S3KJruClk5FccwFwtQbsegkAyZOm+3wXW/Z2gxywVZvdbh+12abkFusRI0EdwFJspC7gYakG9Ml1iPW4kYLr2hXK2RrTGOUAo7VwI/QkNkJqaybb/A5G1vuvNqZjpOSWZhCBcM2Iheo6NSk00MX1upwAHB6e8hpRQIDAQAB`,

      classYear: this.getYearsDesc(2016),
    };
  },
  created() {
    this.getUserInfo();
    this.selectUser();
    this.getIndex();
    this.getCertificateRecord();
  },
  methods: {
    getYearsDesc(startYear = 2018) {
      const current = new Date().getFullYear();
      const years = [];
      for (let y = current; y >= startYear; y--) years.push(y);
      return years;
    },

    resetQuery() {
      this.formInline = {
        classYear: 2025,
        requiredType: undefined,
        courseType: undefined,
        pageNo: 1,
        pageSize: 12,
      };
      this.selectUser();
    },
    async success(captchaData) {
      const encryptor = new JSEncrypt();
      // 使用jsencrypt库进行加密
      encryptor.setPublicKey(this.publicKey);
      setPassword({
        ...this.form,
        idCardNo: encryptor.encrypt(this.form.idCardNo),
        password: undefined,
        newPassword: encryptor.encrypt(this.form.newPassword),
        captchaData: captchaData,
      }).then((res) => {
        if (res.code == 200) {
          this.form = {
            realName: undefined,
            idCardNo: undefined,
            newPassword: undefined,
            password: undefined,
          };
          this.$message.success("修改密码成功！");
          setTimeout(() => {
            this.$router.push("/login");
          }, 1000);
        } else {
          if (res.msg) {
            this.$message.warning(res.msg);
          } else {
            this.$message.warning("修改密码失败");
          }
        }
      });
    },
    handleCurrentChange(val) {
      console.log("handleCurrentChange");
      console.log(val);
      this.formInline.pageNo = val;
      this.selectUser();
    },
    handlePrevClick(val) {
      console.log("handlePrevClick");
      console.log(val);
      this.formInline.pageNo = val;
      this.selectUser();
    },
    handleNextClick(val) {
      console.log("handleNextClick");
      console.log(val);
      this.formInline.pageNo = val;
      this.selectUser();
    },
    handlekaoshi(item) {
      this.$router.push({
        path: "/examinationPaper",
        query: {
          classGroupId: item.classGroupId,
        },
      });
    },
    async getCertificateRecord() {
      const res = await getCertificateRecord();
      this.certificateList = res.result.records || [];
    },

    setPassword() {
      if (this.form.password != this.form.newPassword) {
        return this.$message.warning("密码不一致, 请重新输入");
      }
      this.$refs.verify.show();
    },
    async sendCode() {
      if (!this.form.phoneNumber) {
        this.$message.warning("请先输入手机号！");
        return;
      }
      this.time = 60;
      this.showTime = true;
      let timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          this.showTime = false;
          clearInterval(this.timer);
        }
      }, 1000);
      let res = await captcha({
        phoneNumber: this.form.phoneNumber,
        smsScene: "CHANGE_PASSWORD",
      });
      // 模拟发送验证码的逻辑
      this.$message.success("验证码已发送到您的手机！");
    },
    handleNav(item) {
      if (item.name == "退出登录") {
        this.loginOut();
        return;
      }

      if (item.name == "我的证书") {
        this.$router.push("/myCertificate");
        return;
      }
      this.navActiveName = item.name;
      this.navList.forEach((e, i) => {
        if (e.name == item.name) {
          e.active = true;
          this.navActiveName = item.name;
        } else {
          e.active = false;
        }
      });
    },
    onHistoryPrint() {
      this.handleNav({ name: "打印记录" });
    },
    async examination(item) {
      console.log(item);
      this.$router.push({
        path: "/examinationPaper",
        query: { id: item.id, examType: 3 },
      });
    },
    // 获取学员档案
    async mySchoolClass() {
      const res = await mySchoolClass();
      this.archiveInfo = res.result || [];
    },

    async getUserStatistics() {
      this.loading = true;
      const res = await getUserStatistics();
      res.result.onlineDuration = this.$util.formatSeconds(
        res.result.onlineDuration
      );

      this.myInfo = res.result;
      this.loading = false;
    },
    async getUserInfo() {
      try {
        let res = await getUserInfo();
        if (res.code == 200) {
          // 信息脱敏
          res.data.realName = res.data.realName.slice(0, 1) + "**";
          // 手机号中间4未替换为*号
          res.data.phoneNumber =
            res.data.phoneNumber.slice(0, 3) +
            "****" +
            res.data.phoneNumber.slice(7);
          this.userInfo = res.data;
        } else {
          this.userInfo = {};
        }
      } catch (error) { }
    },
    async selectUser() {
      this.loading2 = true;
      try {
        let res = await pageMyClassGroupList({
          ...this.formInline,
        });
        this.loading2 = false;

        if (res.result.records) {
          res.result.records.forEach((item) => {
            if (item.classGroupLogo) {
              item.classGroupLogo = item.classGroupLogo.replace(
                "https://xzzhuanji.cn/ework/",
                "https://zwyun.xzzhuanji.cn:18443/zhuanji/"
              );
              item.classGroupLogo = item.classGroupLogo.replace("/202508", "");
            }
            if (item.classGroupLogoBase64) {
              item.classGroupLogo = `data:image/jpeg;base64,${item.classGroupLogoBase64}`;
            }
          });
        }
        this.courseList = res.result.records || [];
        this.totalNum = res.result.total;
      } catch { }
    },
    async getIndex() {
      try {
        let column = await cmsApi.getColumn({
          moduleId: "1824109345609756674",
          columnType: "notice",
        });
        if (column.code == 200) {
          let article = await cmsApi.getArticleType({
            columnId: column.result[0].id,
            moduleId: column.result[0].moduleId,
            type: 2,
          });
          this.activities = article.result.list;
        }
      } catch { }
    },

    handleUrl(item) {
      // this.$router.push({
      //   path: "/course/video",
      //   query: {
      //     classId: item.classId,
      //     sectionId: item.classSectionId,
      //     classGroupId: item.classGroupId,
      //   },
      // });
      this.$router.push({
        path: "/courseDetails",
        query: { classGroupId: item.classGroupId },
      });
    },
    handleUrl2(item) {
      if (item.toUrl) {
        this.$router.push({
          path: item.toUrl,
        });
      }
    },
    // 退出登录
    loginOut() {
      if (this.$route.path === "/login") {
        return;
      }
      this.$confirm("确定退出吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.removeItem("userInfo");
          localStorage.removeItem("userCurriculum");
          localStorage.removeItem("cratList");
          localStorage.removeItem("token");
          this.$message({
            type: "success",
            message: "退出成功!",
          });
          this.$router.push("/login");
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.mian {
  padding: 0;

  .navList {
    width: 210px;
    min-height: 560px;
    background: #ffffff;
    border-radius: 10px;
    padding: 30px 20px;

    .item {
      display: flex;
      align-items: center;
      height: 58px;
      padding: 4px 10px;

      font-weight: normal;
      box-sizing: border-box;
      color: #4a4a4a;
      padding-right: 40px;
      font-size: 16px;
      cursor: pointer;

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 20px;
        background: #ccc;
      }

      .title {
        padding-left: 20px;
      }
    }

    .active {
      background: #0d6fc2;
      color: #fff;
      border-radius: 10px;
    }
  }

  .content {
    width: 1110px;
    background: #fff;
    border-radius: 10px;
    padding: 30px 40px;
    box-sizing: border-box;

    .cards {
      display: flex;
      flex-wrap: wrap;
      // 设置间距 不要用margin 也不要padding
      gap: 20px;

      .item {
        box-sizing: border-box;
        border-radius: 10px;
        font-size: 14px;
        border: 1px solid #e1e1e1;
        padding: 20px;
        box-sizing: border-box;
        width: calc(50% - 20px);

        .keshi {
          width: 100%;
          font-weight: normal;
          font-size: 14px;
          color: #9b9b9b;
          // 超过2行显示省略号
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .subTitle {
          width: 100%;
          font-size: 14px;
          color: #4a4a4a;
          margin-bottom: 10px;
          color: #000;
          // white-space: nowrap; /* Ensure text is on a single line */
          // overflow: hidden; /* Hide overflow text */
          // text-overflow: ellipsis; /* Show ellipsis for overflow text */
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.itemBody {
  display: flex;
  background: white;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 200px;
  height: 130px;
  border-radius: 10px;
  margin-right: 10px;

  .itemLogo {
    position: absolute;
    left: -3px;
    top: -3px;

    width: 80px;
    height: 80px;
  }
}

.proBg {
  flex: 1;
  height: 10px;
  background-color: #efefef;
  border-radius: 20px;

  .proDetail {
    width: 100px;
    height: 10px;
    background: #0d6fc2;
    border-radius: 20px;
  }
}

.jixu {
  flex: 1;
  padding: 0px 10px;
  border-radius: 5px;
  cursor: pointer;
  height: 30px;
  border: 1px solid #e1e1e1;

  font-weight: normal;
  font-size: 14px;
  color: #4a4a4a;
}

.moni {
  flex: 1;
  background: linear-gradient(180deg, #41a0f1 0%, #0a5b9f 100%);
  color: #fff;
  padding: 0px 10px;
  border-radius: 5px;
  cursor: pointer;
  height: 30px;
}

.rlist {
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    padding-left: 40px;
  }
}

.nlist {
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    padding-right: 40px;

    .left {
      width: 350px;
      display: flex;
    }
  }
}

.rowBox {
  display: flex;
  align-items: center;

  .list {
    display: flex;
    justify-content: center;

    .item {
      text-align: center;
      margin-right: 40px;

      .value {
        font-size: 20px;
        color: #4a4a4a;
      }

      .name {
        font-size: 16px;
        color: #4a4a4a;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.container {
  box-sizing: border-box;
}

.laiyuan {
  height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.row {
  color: rgb(93, 92, 92);
  font-size: 14px;
  border: 1px solid #e6e6e6;
  padding: 0px 10px;
}

.rowSpan {
  display: inline-block;
  width: 120px;
  padding: 16px 0px;
  margin-right: 10px;
  border-right: 1px solid #e6e6e6;
}

.user {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #616161;

  .avatar {
    width: 60px;
    height: 60px;
    border: 2px solid #fff;
    margin-right: 30px;
  }

  .name {
    .userName {
      font-weight: normal;
      font-size: 30px;
      color: #4a4a4a;
    }
  }
}

.table {
  display: table;
  width: 100%;
  border-collapse: collapse;
}

.table-row {
  display: table-row;
}

.table-cell {
  display: table-cell;
  padding: 8px;
  border: 1px solid #ddd;
  text-align: center;
}
</style>
